import { StringConvertRule } from 'shared';
import { convertString } from '../../../converter';

export const convertInputDateValue = (
  stringConvertRule: StringConvertRule | undefined,
  updateValue: string | undefined = '',
): string => {
  if (stringConvertRule == null) {
    return updateValue;
  }
  const convertValue = convertString(stringConvertRule);
  const convertedValue = convertValue(updateValue);
  return convertedValue;
};
